import Newsletter_38Container from "./container/Newsletter_38Container";
export default Newsletter_38Container;
